import React from "react";
import img from './qurancover.png';
import { useState ,useEffect} from "react";
import { FaFacebookF, FaInstagram, FaEnvelope,FaBars,FaTimes} from "react-icons/fa";
import { Link } from "react-router-dom";
import Contact from "./Contact";
import C from "./C";
import Navbar from "./Navbar";



const Home = () => {
  //FundingBar-----------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------
  const [fundsRaised, setFundsRaised] = useState(0);
  const [goalAmount, setGoalAmount] = useState(35000);
  const [progressPercentage, setProgressPercentage] = useState(0);

  useEffect(() => {
    fetch("https://www.paypal.com/donate/?hosted_button_id=RLCNCZCY9FR7C")
      .then((response) => response.json())
      .then((data) => {
        setFundsRaised(data.total_donated);
        setGoalAmount(data.target);
        setProgressPercentage(data.progress);
      })
      .catch((error) => console.error("Error fetching donation data:", error));
  }, []);
  //------------------------------------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------------------
  

    const [isCalendarLoaded, setIsCalendarLoaded] = useState(false);
  
    const loadCalendarScheduler = () => {
      setIsCalendarLoaded(true); // Hide button & show calendar
  
    }
    const closeCalendar = () => {
      setIsCalendarLoaded(false);
    };

  return (
   <> 
   <Navbar/>
    <div className="bg-gray-100 min-h-screen  flex flex-col items-center">
      {/* Navbar */}
     
      {/* Hero Section */}
      {/* Hero Section */}
      <div className="relative w-full h-screen flex items-center justify-center">
  {/* Background Image */}
  <img 
    src="https://media.gettyimages.com/id/1383965120/video/abstract-holy-quran-concept-loopable-bokeh-animation-soft-background-the-koran-cover.jpg?s=640x640&k=20&c=sPRXT5gp0XRLUeFyjdItkfBrwHtmXliZUPwppJ96a5E=" 
    alt="Quran Cover" 
    className="absolute inset-0 w-full h-full object-cover"
  />
  
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-70"></div>
  
  {/* Centered Text Content */}
  <div className="relative z-60 text-white text-center px-4">
    <h2 className="text-5xl md:text-5xl font-semibold transition duration-500 font-serif m-2">
      The Quran Explained
    </h2>
    <h2 className="text-xl md:text-2xl transition duration-500 font-serif">
    The first single-volume Quran Commentary according to the teachings of the 
    </h2>
    <h2 className="text-xl md:text-2xl transition duration-500 font-serif">
 Holy Prophet (PBUH) and his Household
    </h2>

    {/* Buttons */}
 <div className="mt-9 w-full flex items-center justify-center">
  <div className="flex flex-wrap items-center justify-center gap-6 w-full max-w-4xl">

    {/* DONATE (PayPal) */}
<a
  href="https://www.paypal.com/donate/?hosted_button_id=RLCNCZCY9FR7C"
  target="_blank"
  rel="noopener noreferrer"
  className="md:flex-1 min-w-[180px] w-full md:w-auto"
>
  <button
    type="button"
    className="w-full h-14 flex items-center justify-center gap-2 px-4 bg-white text-blue-800 text-sm font-semibold
               border border-gray-300 rounded-xl shadow-sm hover:shadow-md transition-all"
  >
    <img
      src="https://cdn.pixabay.com/photo/2018/05/08/21/29/paypal-3384015_640.png"
      alt="PayPal"
      className="w-10 h-10"
    />
    <span>Donate Now</span>
  </button>
</a>


    {/* SADQA (FULL IMAGE BUTTON) */}
    <a
      href="https://mysadaqa.com/Qurancommentary"
      className="md:flex-1 min-w-[180px] w-full md:w-auto block rounded-xl overflow-hidden border border-gray-300 shadow-sm hover:shadow-md transition-all"
      aria-label="Sadqa"
    >
      <img
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPXD1y4J83MpLeAEiXGELEg4IIxmMpxLzTFw&s"
        alt="Sadqa"
        className="w-full h-14 object-cover"
      />
    </a>

    {/* DOWNLOAD PDF */}
    <a
      href="https://drive.google.com/file/d/1tC_uBVGC_AC62--KOe-At51yX_aXPjgi/view?usp=drive_link"
      download
      className="md:flex-1 min-w-[180px] w-full md:w-auto h-14 flex items-center justify-center gap-2 px-4 bg-white text-blue-800 text-sm font-medium 
                 border border-gray-300 rounded-xl shadow-sm hover:shadow-md transition-all"
    >
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
        <path d="M21 15v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4" stroke="#1e3a8a" strokeWidth="1.5"/>
        <path d="M7 10l5 5 5-5" stroke="#1e3a8a" strokeWidth="1.5"/>
        <path d="M12 15V3" stroke="#1e3a8a" strokeWidth="1.5"/>
      </svg>
      <span>Download PDF</span>
    </a>

    {/* BOOK APPOINTMENT */}
    <button
      onClick={loadCalendarScheduler}
      className="md:flex-1 min-w-[180px] w-full md:w-auto h-14 flex items-center justify-center gap-2 px-4 bg-white text-blue-800 text-sm font-medium 
                 border border-gray-300 rounded-xl shadow-sm hover:shadow-md transition-all"
    >
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="5" width="18" height="16" rx="2" stroke="#1e3a8a" strokeWidth="1.5" />
        <path d="M16 3v4M8 3v4" stroke="#1e3a8a" strokeWidth="1.5" />
        <path d="M3 11h18" stroke="#1e3a8a" strokeWidth="1.5" />
      </svg>
      <span>Book an Appointment</span>
    </button>

  </div>


</div>

  </div>
</div>





{/* Download PDF Section */}
<div className="w-full flex flex-col items-center justify-center text-center py-8 md:py-12 bg-blue-100 mt-8 md:mt-12 px-4">
  <h2 className="text-2xl md:text-3xl font-serif text-blue-700 mb-4">
    Download the the Quran Explained Commentary
  </h2>
  <p className="text-gray-700 text-base md:text-lg max-w-2xl mx-auto mb-6">
    Get access to an insightful commentary on the Qur'an, grounded in the teachings of the Ahl al-Bayt. Download the latest volume now.
  </p>
  <a 
    href="https://drive.google.com/file/d/1tC_uBVGC_AC62--KOe-At51yX_aXPjgi/view?usp=drive_link" 
    download 
    className="bg-blue-700 text-white px-6 py-3 rounded-full text-lg font-semibold transition duration-300 hover:bg-blue-800 shadow-md flex items-center justify-center space-x-2"
  >
    <svg className="w-5 md:w-6 h-5 md:h-6 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v12m0 0l3-3m-3 3l-3-3m-9 5a2 2 0 012-2h16a2 2 0 012 2v3H3v-3z"></path>
    </svg>
    <span>Download PDF</span>
  </a>
 
</div>



      {/* More About Our Mission Section */}
      <div className="w-full mt-12 flex flex-col md:flex-row items-center justify-between px-4">
  <img
    src="https://t4.ftcdn.net/jpg/08/25/04/33/240_F_825043353_60Cy5hAKXAF3iv7I7WsEUgVZBGS2jwmm.jpg"
    alt="Mission Image"
    className="w-full md:w-1/2 h-auto max-h-[400px] object-cover rounded-lg"
  />
  <div className="md:w-1/2 p-6 md:p-8 text-center md:text-left">
    <h2 className="text-2xl md:text-4xl font-serif text-blue-700 mb-2">
      More About Our Mission
    </h2>
    <div className="w-24 md:w-[450px] h-1 bg-blue-700 mx-auto md:mx-0 mb-4"></div> {/* Responsive Underline */}
    <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
      The Qur'an Explained is a groundbreaking initiative: the first single-volume  commentary of the Qur'an in English, grounded in the teachings of the Ahl al-Bayt. This work fills a critical gap in English-language Islamic scholarship, making the deeper meaning of the Qur'an accessible to a global audience.
    </p>
    <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
      Led by scholar and translator Alexander Khaleeli, who brings over 15 years of experience in Arabic and Persian translations, the project has received validation from renowned scholars such as Shaykh Abbas Jaffer, Shaykh M S Bahmanpour, and Sayyid Ammar Nakshawani. With nearly one-third of the translation already completed, the goal is to finalize the first volume by Ramadhan 2025 and the full work by Ramadhan 2026.
    </p>
    <Link to="/about">
      <button className="bg-black text-white px-6 py-2 rounded-full text-lg transition duration-300 hover:bg-gray-800">
        Learn More
      </button>
    </Link>
  </div>
</div>

<div className="w-full mt-12 flex flex-col items-center justify-center px-4 bg-blue-100 py-12 text-center">
  <h2 className="text-2xl md:text-4xl font-serif text-blue-700 mb-2">
    Book an Appointment
  </h2>
  <div className="w-24 md:w-[450px] h-1 bg-blue-700 mb-4"></div> {/* Responsive Underline */}
  <p className="text-gray-700 text-sm md:text-base leading-relaxed max-w-2xl mb-6">
    Schedule a one-on-one session to discuss the project, ask questions, or explore how you can contribute. Choose a time that works for you.
  </p>
  <p className="text-gray-700 text-sm md:text-base leading-relaxed max-w-2xl mb-6">
    This 20-minute session allows for direct engagement with the team, ensuring clarity on your inquiries. Whether you're interested in supporting the project or understanding its impact, we welcome your participation.
  </p>
  {!isCalendarLoaded ? (
        <button
          onClick={loadCalendarScheduler}
          className="bg-white text-black px-6 py-3 rounded-lg text-lg font-small transition duration-300 hover:bg-gray-300"
        >
          Book an Appointment
        </button>
      ) : (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={closeCalendar} // Close when clicking outside the frame
        >
          <div
            className="w-[90%] max-w-5xl h-[90vh] bg-white border border-gray-300 rounded-lg shadow-lg relative"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the frame
          >
            {/* Close Button */}
            <button
              onClick={closeCalendar}
              className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-full text-sm"
            >
              ✕ Close
            </button>

            {/* Google Calendar iframe */}
            <iframe
              src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ1zIY5-uYuzfDp9-vvXw_f7Tre8C7Dld-va2jEeGjWm8RZd1cWdbXdz0Q8_XVqlpwa8Qdtgr9Qk?gv=true"
              className="w-full h-full rounded-lg"
              style={{ backgroundColor: "white" }}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
</div>

         
   {/* Support Section */}
 <div
  className="w-full p-12 bg-blue-50 border-t border-gray-300 relative"
  style={{
    backgroundImage:
      "url('https://media.istockphoto.com/id/1085351298/photo/the-holy-quran-book-of-muslims.jpg?s=612x612&w=0&k=20&c=4nFkwkvN0gcPyH7aWL8JyqosuNM9DOrrgs4OobW3_YI=')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="absolute inset-0 bg-blue-900 opacity-90"></div>

  <div className="relative z-10">
    <h2 className="text-2xl md:text-4xl font-serif text-white text-center mb-6">
      Support the Quran Explained Project
    </h2>

    <div className="w-24 md:w-[450px] h-1 bg-white mx-auto mb-4"></div>

    <p className="text-white text-sm md:text-base leading-relaxed text-center max-w-2xl mx-auto mb-8">
      Your generous support helps us complete this vital scholarly work. With
      your donations, we can bring a transformative Quranic commentary to the
      world, rooted in the teachings of the Ahl al-Bayt.
    </p>

    {/* Banner-size Buttons */}
    <div className="mt-8 w-full flex items-center justify-center">
      <div className="flex flex-wrap items-center justify-center gap-6 w-full max-w-3xl">

{/* DONATE NOW BUTTON */}
<a
  href="https://www.paypal.com/donate/?hosted_button_id=RLCNCZCY9FR7C"
  target="_blank"
  rel="noopener noreferrer"
  className="flex-1 min-w-[250px]"
>
  <button
    type="button"
    className="w-full flex items-center justify-center gap-3 
               px-8 py-4 bg-white text-blue-800 font-semibold text-lg
               border border-gray-300 rounded-xl shadow-sm hover:shadow-md transition-all
               h-[60px]"
  >
    <img
      src="https://cdn.pixabay.com/photo/2018/05/08/21/29/paypal-3384015_640.png"
      alt="PayPal"
      className="h-14 w-auto"
    />
    <span>Donate Now</span>
  </button>
</a>


        {/* MY SADQA BUTTON (same size) */}
        <a
          href="https://mysadaqa.com/Qurancommentary"
          className="flex-1 min-w-[250px] block rounded-xl overflow-hidden 
                     border border-gray-300 shadow-sm hover:shadow-md transition-all h-[60px]"
        >
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPXD1y4J83MpLeAEiXGELEg4IIxmMpxLzTFw&s"
            alt="My Sadqa"
            className="w-full h-full object-cover"
          />
        </a>

      </div>
    </div>
  </div>
</div>

  </div>









<C/>


      {/* Footer */}

    </>
  );
};

export default Home;
